const DEFAULT_APP_ORIGIN = 'https://app.tabbio.com';

/**
 * Nothing on `app.tabbio.com` is indexable, and this cannot be a per-path
 * allowlist however much we would like one.
 *
 * The Expo web export is a single-shell SPA: one `index.html`, returned with
 * HTTP 200 for every path. A crawler therefore reads the same `robots` tag no
 * matter which URL it asked for, and that tag lives in `src/app/+html.tsx`
 * where no pathname is available. `WebPageMetadata` does render a per-route
 * tag, but client-side, after Googlebot has already read the HTML, and where
 * two robots tags disagree the most restrictive one wins, so a client-side
 * `index, follow` could never have re-opened a shell marked `noindex`.
 *
 * The previous allowlist (`/`, `/login`, `/register`, `/forgot-password`) was
 * therefore never enforceable, and the cost of pretending otherwise was real:
 * with the shell set to `index, follow`, every unmatched path (including
 * marketing URLs that only exist on `www`) answered 200 and indexable, and
 * this host reached roughly position 6 for the bare "tabbio" brand query
 * against `www`. Confirmed live in Search Console, August 2026.
 *
 * Marketing and profile SEO belong to `www.tabbio.com`. Making any app route
 * indexable again needs real per-route HTML (server rendering or a prerender
 * step), not a change here.
 */
export function isIndexableAppPath(_pathname: string) {
  return false;
}

export function buildAppCanonicalUrl(
  pathname: string,
  origin = DEFAULT_APP_ORIGIN,
) {
  const normalizedOrigin = origin.replace(/\/+$/, '');
  return pathname === '/' ? `${normalizedOrigin}/` : `${normalizedOrigin}${pathname}`;
}
